import React from 'react';
import PropTypes from 'prop-types';
import ConfirmationModal from './ConfirmationModal';
import i18n from '../../src/i18n/translate';

export default class ShowMoreText extends React.Component {
  static propTypes = {
    text: PropTypes.string,
    maxCharacters: PropTypes.number,
    showMoreLabel: PropTypes.string,
    showMoreClass: PropTypes.string,
    modalTitle: PropTypes.string,
    modalCloseText: PropTypes.string
  };

  static defaultProps = {
    text: '',
    maxCharacters: 100
  };

  constructor(props) {
    super(props);

    this.state = {};
  }

  onShowModal = () => {
    this.setState({ showModal: true });
  }

  onCloseModal = () => {
    this.setState({ showModal: undefined });
  }

  renderText = () => {
    const { text, maxCharacters } = this.props;
    let renderedText;
    if (!text || text.length <= maxCharacters) {
      renderedText = text;
    } else {
      // find the last space before the maxCharacter limit
      const lastIndex = text.lastIndexOf(' ', maxCharacters);
      // get rid of any ending punctuations
      const truncatedText = lastIndex > -1 ? text.substr(0, lastIndex) : '';
      const nonWordCharacters = truncatedText.match(/[.,"'\-]*$/);
      renderedText = truncatedText.substr(0, nonWordCharacters.index);
    }

    return (<span>
      {renderedText}
    </span>);
  }

  renderShowMoreLink = () => {
    const { text, maxCharacters, showMoreLabel, showMoreClass } = this.props;
    const label = showMoreLabel || i18n.t('show more');
    if (!text || text.length <= maxCharacters) {
      return null;
    }
    return (<span>&nbsp;&hellip;
      <a className={showMoreClass}
        onClick={this.onShowModal}>{label}
      </a>
    </span>);
  }

  renderShowMoreModal = () => {
    const { text, modalTitle, modalCloseText } = this.props;
    return (<ConfirmationModal
      show={this.state.showModal}
      title={modalTitle}
      canClose={true}
      canClickOff={true}
      confirmButtonText={modalCloseText}
      confirmOnly={true}
      onCancel={this.onCloseModal}
      onConfirm={this.onCloseModal}>
      {text}
    </ConfirmationModal>);
  }

  render() {
    return (<React.Fragment>
      {this.renderText()}
      {this.renderShowMoreLink()}
      {this.renderShowMoreModal()}
    </React.Fragment>);
  }
}
